import React from 'react';
import Loader from '@/components/common/Loader';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { LazyDialog } from '@/modules/Dialogs';
import lazyWithRetry from '@/utils/lazyWithRetry';
import { type CreateEditTicketOptionDialogContentProps } from './CreateEditTicketOptionDialogContent';

const CreateEditTicketOptionDialogContent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "create-edit-ticket-option" */
      '@/modules/Campaigns/components/CreateEditTicketOptionDialogContent'
    ),
);

export default function CreateEditTicketOptionDialog({
  isEventbrite,
  onClose,
  ticketedEventId,
  ticketOption,
  ...dialogProps
}: CreateEditTicketOptionDialogContentProps) {
  const fallback = <Loader isCentered />;

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog
        scroll="paper"
        maxWidth="sm"
        fullWidth
        onClose={onClose}
        {...dialogProps}
      >
        <CreateEditTicketOptionDialogContent
          isEventbrite={isEventbrite}
          onClose={onClose}
          ticketedEventId={ticketedEventId}
          ticketOption={ticketOption}
        />
      </LazyDialog>
    </React.Suspense>
  );
}
